module.exports = __webpack_public_path__ + "static/img/jpxs.c4ac8df3.jpg";